import { cn } from "@lib/cn";
import { memo } from "react";

type CustomLegendItemProps = {
  device: string;
  color: string;
  Icon: React.ElementType;
  percentage: number;
  isHidden: boolean;
  onToggle: (name: string) => void;
};

export const CustomLegendItem = memo(
  ({
    device,
    color,
    Icon,
    percentage,
    isHidden,
    onToggle,
  }: CustomLegendItemProps) => {
    return (
      <button
        type="button"
        onClick={() => onToggle(device)}
        className={cn(
          "tw-grid tw-grid-cols-[auto_auto] tw-gap-8 tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-transition-all tw-duration-300 tw-bg-transparent tw-border-0 tw-p-0 tw-text-left -sm:tw-gap-4",
          isHidden && "tw-opacity-40",
        )}
      >
        <div className="tw-flex tw-items-center tw-gap-1">
          <span
            className="tw-block tw-size-3 tw-rounded-sm tw-mr-1"
            style={{ backgroundColor: color }}
          />
          <Icon className="tw-size-4 tw-text-blue" />
          <span className="tw-font-sans tw-text-xs tw-font-normal tw-text-blue">
            {device}
          </span>
        </div>
        <span className="tw-font-sans tw-text-xs tw-font-semibold tw-text-blue-500 tw-ml-auto">
          {percentage}%
        </span>
      </button>
    );
  },
);
